import { useEffect, useState } from "react";
import { api } from "./api";

const cache = {};

export const useCollection = (endpoint, fallback = []) => {
    const [data, setData] = useState(cache[endpoint] || null);

    useEffect(() => {
        let mounted = true;
        if (cache[endpoint]) {
            setData(cache[endpoint]);
            return undefined;
        }
        api.get(endpoint)
            .then(({ data: d }) => {
                if (Array.isArray(d) && d.length > 0) {
                    cache[endpoint] = d;
                    if (mounted) setData(d);
                }
            })
            .catch(() => {});
        return () => {
            mounted = false;
        };
    }, [endpoint]);

    return data && data.length > 0 ? data : fallback;
};

export const useCollectionState = (endpoint) => {
    const [state, setState] = useState(() =>
        cache[endpoint] ? { items: cache[endpoint], loading: false } : { items: [], loading: true },
    );

    useEffect(() => {
        let mounted = true;
        if (cache[endpoint]) {
            setState({ items: cache[endpoint], loading: false });
            return undefined;
        }
        api.get(endpoint)
            .then(({ data: d }) => {
                const items = Array.isArray(d) ? d : [];
                if (items.length > 0) cache[endpoint] = items;
                if (mounted) setState({ items, loading: false });
            })
            .catch(() => {
                if (mounted) setState({ items: [], loading: false });
            });
        return () => {
            mounted = false;
        };
    }, [endpoint]);

    return state;
};

export default useCollection;
